import { Button } from 'antd';
import styled from 'styled-components';

import colors from '../../styles/colors';

export const ButtonPrimary = styled(Button)`
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 16px;
  color: ${colors.$light};
  padding: 5px 16px 5px 16px;
  border: 1px solid ${colors.tmov_green};
  border-radius: 2px !important;
  background: ${colors.tmov_green};

  display: flex;
  align-items: center;

  &:focus,
  &:active {
    color: ${colors.$light};
    border: 1px solid ${colors.tmov_green};
    background: ${colors.tmov_green};
  }

  &:hover {
    color: ${colors.$light};
    border-color: ${colors.light_green};
    background: ${colors.light_green};
  }

  span {
    display: flex;
    align-items: center;
  }
`;

export const ButtonSecondary = styled(Button)`
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 16px;
  color: ${colors.$greyscale_black};
  padding: 5px 16px 5px 16px;
  border: 1px solid ${colors.$greyscale_light_grey_1};
  border-radius: 2px !important;
  background: ${colors.$light};

  display: flex;
  align-items: center;

  &:focus,
  &:active {
    color: ${colors.$greyscale_black};
    border: 1px solid ${colors.$greyscale_light_grey_1};
    background: ${colors.$light};
  }

  &:hover {
    color: ${colors.$greyscale_black};
    border-color: ${colors.$greyscale_light_grey_1};
    background: ${colors.$greyscale_light_grey_1};
  }

  span {
    display: flex;
    align-items: center;
  }
`;

export const ButtonCancel = styled(Button)`
  display: flex;
  align-items: center;

  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 16px;
  color: ${colors.$light};
  padding: 5px 16px 5px 16px;
  border: 1px solid ${colors.$auxiliary_berry};
  border-radius: 2px !important;
  background: ${colors.$auxiliary_berry};

  display: flex;
  align-items: center;

  &:focus,
  &:active {
    color: ${colors.$light};
    border: 1px solid ${colors.$auxiliary_berry};
    background: ${colors.$auxiliary_berry};
  }

  &:hover {
    color: ${colors.$light};
    border-color: ${colors.$auxiliary_berry_1};
    background: ${colors.$auxiliary_berry_1};
  }

  span {
    display: flex;
    align-items: center;
  }
`;
